import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ZonesProvider, LabelsProvider} from "./AppContext";

const roots = document.getElementsByClassName('tx-mrfrimobilprices-map');

for (var i = 0; i < roots.length; i++) {
    const htmlElement = roots[i];
    const productUrl = htmlElement.getAttribute('data-product-url');
    const translationUrl = htmlElement.getAttribute('data-translation-url');

    const fetchTranslation = async () => {
        const data = await (
            await fetch(translationUrl)
        ).json();

        const root = ReactDOM.createRoot(htmlElement);
        root.render(
            <>
                <LabelsProvider labels={data}>
                    <ZonesProvider>
                        <App productUrl={productUrl} translationUrl={translationUrl}/>
                    </ZonesProvider>
                </LabelsProvider>
            </>
        );
    }

    fetchTranslation();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
